/** Placement in the target document viewport, using CSS coordinates. */
export function positionPreview(anchor, size, viewport, { gap = 8, margin = 8 } = {}) {
  const leftEdge = viewport.left + margin;
  const rightEdge = viewport.left + viewport.width - margin;
  const below = Math.max(0, viewport.top + viewport.height - margin - anchor.bottom - gap);
  const above = Math.max(0, anchor.top - gap - viewport.top - margin);
  const placement = below >= size.height || below >= above ? 'bottom': 'top';
  const maxHeight = placement === 'bottom' ? below: above;
  const height = Math.min(size.height, maxHeight);
  return {
    left: Math.max(leftEdge, Math.min(anchor.left, rightEdge - size.width)),
    top: placement === 'bottom' ? anchor.bottom + gap: anchor.top - gap - height,
    placement,
    maxHeight,
  };
}
